const TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

async function reverseLabel(lat, lng) {
  try {
    const r = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?limit=1&access_token=${TOKEN}`
    );
    const j = await r.json();
    if (j.features?.[0]) return j.features[0].text || j.features[0].place_name;
  } catch { /* noop */ }
  return null;
}

// Coarse location from IP (no permission prompt) — used as a fallback.
async function ipLocation() {
  try {
    const r = await fetch("https://ipwho.is/");
    const j = await r.json();
    if (j && j.success !== false && j.latitude && j.longitude) {
      const label = j.city ? `${j.city}${j.region_code ? `, ${j.region_code}` : ""}` : "Current location";
      return { lat: j.latitude, lng: j.longitude, label };
    }
  } catch { /* noop */ }
  return null;
}

// Precise browser geolocation with an IP-based fallback (works even when the
// permission is denied or blocked in an iframe/preview).
export function getCurrentPickup() {
  return new Promise((resolve) => {
    const fallback = () => ipLocation().then(resolve);
    if (!navigator.geolocation) return fallback();
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude: lat, longitude: lng } = pos.coords;
        const label = (await reverseLabel(lat, lng)) || "Current location";
        resolve({ lat, lng, label });
      },
      () => fallback(),
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 }
    );
  });
}

// Straight-line distance (miles) between two {lat,lng} points — synchronous, no API call.
export function haversineMiles(a, b) {
  if (!a || !b || a.lat == null || b.lat == null) return null;
  const R = 3958.8, toR = Math.PI / 180;
  const dLat = (b.lat - a.lat) * toR, dLng = (b.lng - a.lng) * toR;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(a.lat * toR) * Math.cos(b.lat * toR) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.asin(Math.sqrt(h));
}

// Driving distance (miles) + duration (minutes) between two points.
export async function getRouteEstimate(a, b) {
  if (!a || !b) return null;
  try {
    const r = await fetch(
      `https://api.mapbox.com/directions/v5/mapbox/driving/${a.lng},${a.lat};${b.lng},${b.lat}?overview=false&access_token=${TOKEN}`
    );
    const j = await r.json();
    if (j.routes?.[0]) {
      return { miles: j.routes[0].distance / 1609.34, minutes: Math.round(j.routes[0].duration / 60) };
    }
  } catch { /* noop */ }
  return null;
}
